import {Component, EventEmitter, Inject, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {environment} from 'src/environments/environment.prod';
import {of, Subject} from 'rxjs';
import {catchError, debounceTime, map, switchMap, takeUntil} from 'rxjs/operators';

import {CompanyService} from 'src/app/shared/services/company.service';
import {Companies, CompanySearchService} from 'src/app/admin/company-search.service';
@Component({
    selector: 'app-add-company',
    templateUrl: './add-company.component.html',
    styleUrls: ['./add-company.component.scss'],
    standalone: false
})
export class AddCompanyComponent implements OnInit, OnDestroy {
  popupTitle = 'Add company to';
  form: UntypedFormGroup;
  companies: Companies[];
  searchCompanyName = '';
  selectedCompany;
  dropdownCompanies = false;
  loaded = false;
  deployUrl;
  private destroy$ = new Subject<void>();
  // debounced company typeahead: one request after typing settles, switchMap cancels stale ones.
  // carries the firstSearch flag so the initial load does not pop the dropdown open
  private companySearch$ = new Subject<boolean>();

  constructor(
    public dialogRef: MatDialogRef<AddCompanyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private companySearchService: CompanySearchService,
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.deployUrl = environment.deploy_url;

    this.companySearch$
      .pipe(
        debounceTime(300),
        switchMap(firstSearch =>
          this.companySearchService.searchCompanies({q: this.searchCompanyName}).pipe(
            map((data: Companies[]) => ({data, firstSearch})),
            catchError(() => of({data: [] as Companies[], firstSearch})),
          ),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe(({data, firstSearch}) => {
        this.companies = data;
        this.loaded = true;
        if (!firstSearch) {
          this.dropdownCompanies = true;
        }
      });

    this.getCompanies(true);
    if (this.data.selectedCompany) {
      this.selectedCompany = this.data.selectedCompany;
    }
    const eventName = this.data.name;
    if (eventName) {
      this.popupTitle = this.popupTitle + ': ' + eventName;
    }

    const company = this.data.company;
    if (company) {
      const comp = {
        name: company.company_name,
        id: company.id,
      };
      this.selectedCompany = comp;
    }
  }

  createForm() {
    this.form = new UntypedFormGroup({
      company: new UntypedFormControl('', Validators.required),
    });
  }

  getCompanies(firstSearch = false) {
    this.companySearch$.next(firstSearch);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setCompany(ev) {
    this.dropdownCompanies = false;
    this.searchCompanyName = '';
    this.selectedCompany = ev;
    this.form.get('company').setValue(ev.id);
  }

  submitForm() {
    const req = this.form.getRawValue();

    this.dialogRef.close({
      success: req,
    });
  }

  removeSelectedCompany() {
    this.selectedCompany = null;
    this.form.get('company').setValue('');
  }

  onInputFocus() {
    if (this.companies && this.companies.length > 0) {
      this.dropdownCompanies = true;
    }
  }

  getImagePath() {
    return this.deployUrl + 'assets/icons/cancel-icon.svg';
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
